<template>
	<article v-show="isOpen" class="app-modal-overlay">
		<header class="app-modal-header u-container">
			<div class="app-modal-header__content">
				<div class="app-modal-close-box">
					<button
						v-if="alwaysOpen"
						@click="alwaysCloseModal"
						class="btn-close-always"
						type="button"
					>
						다시 보지 않기
					</button>
					<a @click="closeModal" class="btn-close-modal" href="javascript:;">
						<i class="ri-close-line"></i>
					</a>
				</div>
				<h2 class="app-modal-title">{{ title }}</h2>
			</div>
		</header>
		<div class="app-modal-body u-container">
			<div class="app-modal-body__content">
				<div class="app-modal-content">
					<slot></slot>
				</div>
			</div>
		</div>
	</article>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		alwaysOpen: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isOpen: false,
		};
	},
	methods: {
		openModal() {
			this.isOpen = true;
		},
		closeModal() {
			this.isOpen = false;
		},
		alwaysCloseModal() {
			this.$emit('alwaysCloseModal');
		},
	},
	created() {
		if (this.alwaysOpen) {
			this.openModal();
		}
	},
};
</script>
